import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const ShipmentManager = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    areaTitle: "",
    price: 0,
    areaPoints: "",
    description: "",
    cityId: 0,
    branchId: branchId,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState("");
  const [editMode, setEditMode] = useState(false);

  const getGridData = async () => {
    const resp = await apiMethod.getShipmentCosts(filterModel.branchId, filterModel.title, filterModel.size, filterModel.part);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
      formModel.cityId = resp.city.id;
      setCity(resp.city);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.areaTitle)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.price)) {
      errors.push('.هزینه باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    setEditMode(false);
    formModel.id = 0;
    formModel.areaTitle = "";
    formModel.price = 0;
    formModel.areaPoints = "";
    formModel.description = "";
    formModel.cityId = 0;
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const editItem = async (id) => {
    setEditMode(true);
    setLoading(true);
    const resp = await apiMethod.getShipmentCostInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.areaTitle = resp.data.areaTitle;
    formModel.price = resp.data.price;
    formModel.areaPoints = resp.data.areaPoints;
    formModel.description = resp.data.description;
    formModel.cityId = resp.data.cityId;
    formModel.branchId = resp.data.branchId;

    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm())
      return false;

    setLoading(true);
    formModel.cityId = city.id;
    setFormModel({ ...formModel })
    const resp = await apiMethod.createShipmentCost(formModel);
    if (!methods.showApiErrors(resp))
      return false;

    await getGridData();
    setShowFormModal(false);
    setLoading(false);
    return true;
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block '>
              <Link to={`/sale/${branchId}/#5`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#5`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                تنظیمات ارسال
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>تنظیمات ارسال
                <a href={`/sale/${branchId}/softwareGuide/#section4`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>تنظیم ارسال جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                {false ? (
                  <div className='my-5'>
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button className='btn btn-outline-purple' onClick={() => { navigate(`/baseinfo/${branchId}/product`) }}>افزودن خدمات</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <table className="table table-striped table-md " >
                      <thead className='align-middle'>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">محدوده</th>
                          <th scope="col vertical-center">هزینه ( ریال)</th>
                          <th scope="col vertical-center">شهر</th>
                          <th scope="col vertical-center">توضیحات</th>
                          <th scope="col vertical-center" width="100px">عملیات</th>
                        </tr>
                      </thead>
                      <tbody className='align-middle'>
                        {gridData.map((item, index) => (
                          <tr key={item.id}>
                            <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                            <td>{item.areaTitle}</td>
                            <td>{methods.addNumSeperator(item.price)}</td>
                            <td>{item.cityTitle}</td>
                            <td>{item.description}</td>
                            <td>
                              <button
                                onClick={() => editItem(item.id)}
                                className='btn btn-sm btn-outline-purple me-2' type='button'>
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              <button
                                onClick={() => selectَItemToDelete(item)}
                                className='btn btn-sm btn-outline-danger' type='button'>
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filterModel.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {makePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </>
                )}
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeShipmentCost(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش تنظیمات ارسال </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">نام محله/محدوده</label>
                  <input type="text" className="form-control" id="title" name="title"
                    value={formModel.areaTitle}
                    onChange={(e) => { setFormModel({ ...formModel, areaTitle: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="city" className="form-label required-label">شهر</label>
                  <select
                    id="city"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.cityId}
                    onChange={(e) => setFormModel({ ...formModel, cityId: e.target.value })}
                  >
                    <option value={city.id} >{city.title}</option>
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="price" className="form-label required-label">هزینه (ریال)</label>
                  <input type="text" className="form-control" id="price" name="price"
                    value={methods.addNumSeperator(formModel.price)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const price = parseInt(inputValue.replace(/,/g, ''));
                      setFormModel({ ...formModel, price: isNaN(price) ? '' : price });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">توضیحات</label>
                  <textarea type="text" className="form-control" id="description" name="description" rows={3}
                    value={formModel.description}
                    onChange={(e) => { setFormModel({ ...formModel, description: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn custome-btn btn-link-purple" onClick={closeModal}>
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'تنظیم ارسال'}
        />
      }
    </>
  );
}

export default ShipmentManager;